import axiosInstance from "../configs/axios/axiosInstance";

const CreditNotesServices = {

    getCreditNoteList: async (filters: any) => {
        const response = await axiosInstance.get('CreditNotes/GetCreditNotesList', { params: filters });
        return response.data;
    },

    getCreditNoteDetails: async (payload: any) => {
        const response = await axiosInstance.get('CreditNotes/GetCreditNotesDetails', { params: payload });
        return response.data;
    },

    uploadCreditNoteFile: async (payload: FormData) => {
        const response = await axiosInstance.post('CreditNotes/UploadCreditNote', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    generateCreditNoteRpaFiles: async (payload: any) => {
        const response = await axiosInstance.post('RPA/ExportCreditNoteRPATemplate', payload);
        return response.data;
    },

     
    deleteCreditNote: async (headerID: string) => {
        const response = await axiosInstance.put('CreditNotes/DeleteCreditNote', null, {
            params: {id: headerID },
        });
        return response.data;
    },

    multiDeleteCreditNotes: async (creditNotesIds: string[]) => {
        const response = await axiosInstance.put('CreditNotes/MultiCreditNoteDelete', {
            creditNotesIds: creditNotesIds
        });
        return response.data;
      },
    

};

export default CreditNotesServices;
